import {Component, input, InputSignal, model, ModelSignal} from '@angular/core';
import {SharedModule} from "../../shared.module";

/**
 * Case à cocher modifiable, sur l'idée de yo-check (✓ / ✗) mais liée en two-way binding :
 * <yo-check-box [(checked)]="..."></yo-check-box>
 */
@Component({
  selector: 'yo-check-box',
  templateUrl: './check-box.component.html',
  styleUrls: ['./check-box.component.scss'],
  standalone: true,
  imports: [SharedModule]
})
export class CheckBoxComponent {

  checked: ModelSignal<boolean> = model(false);
  disabled: InputSignal<boolean> = input(false);

  toggle = (): void => {
    if (!this.disabled()) {
      this.checked.set(!this.checked());
    }
  };
}
